import { useStylesPatientAppRedesign } from 'hooks';
import { EPatientFlow, getCurrentPatientFlow } from 'utils';

export default function useHeaderBrandingConfiguration(isDesktop?: boolean) {
  // Adjust the header based on the branding redesign configuration
  const stylesPatientAppRedesign = useStylesPatientAppRedesign();

  const [patientFlow] = getCurrentPatientFlow();
  if (patientFlow === EPatientFlow.Kiosk) {
    return { includeLanguageSelector: true, includeBarWithLinks: false, includeButtonWithLinks: false, links: [] };
  }

  const includeLanguageSelector =
    !stylesPatientAppRedesign || !!stylesPatientAppRedesign.styles?.theme?.includeLanguageSelector;

  // Include links configured by the branding
  const links = stylesPatientAppRedesign?.styles?.theme?.includeMenuWithLinks?.links || [];
  const includeLinks = !!links.length && !!stylesPatientAppRedesign?.styles?.theme?.includeMenuWithLinks?.enabled;
  const includeBarWithLinks = includeLinks && isDesktop;
  const includeButtonWithLinks = includeLinks && !isDesktop;

  return { includeLanguageSelector, includeBarWithLinks, includeButtonWithLinks, links };
}
